export enum EnergyCertificateType {
  NO_AVAILABLE = 'NO_AVAILABLE',
  USAGE_IDENTIFICATION = 'USAGE_IDENTIFICATION',
  DEMAND_IDENTIFICATION = 'DEMAND_IDENTIFICATION'
}
